export default __webpack_public_path__ + "static/media/espago-mobile-2.32e6bb1e.png";